import { Paper as _Paper, Grid, styled, Typography } from '@mui/material'
import React, { ReactElement } from 'react'

const Paper = styled(_Paper)(({ theme }) => ({
  margin: theme.spacing(2),
  padding: theme.spacing(1),
  background: theme.palette.success.main,
  color: theme.palette.background.default,
  minWidth: 100,
}))

export type BoardProps = {
  icon: ReactElement
  title: string
  description: string
}

function Board(props: React.PropsWithChildren<BoardProps>): React.ReactElement<BoardProps> {
  const { icon, title, description } = props
  return (
    <Paper>
      <Grid
        container
        spacing={1}
        sx={{
          alignItems: 'center',
        }}>
        <Grid>{icon}</Grid>
        <Grid
          container
          direction="column"
          spacing={1}
          size="grow"
          sx={{
            alignItems: 'center',
          }}>
          <Grid>
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
              {title}
            </Typography>
          </Grid>
          <Grid>
            <Typography component="p" variant="h5">
              {description}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default Board
